
import React, { useState } from "react";
import { Box, Button, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from '@mui/icons-material/Add';
import BookIcon from '@mui/icons-material/Book';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DescriptionIcon from '@mui/icons-material/Description';

import PaperWorkDropDown from "../components/SupportWorkerPaperWork"

const ShiftNotesButton: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const iconStyle = {
    fontSize: '5rem', // Adjust the size as needed
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.2)', // Adjust the zoom level as needed
    },
  };


  
  return (
    <div>
      <Button
        sx={{
          bgcolor: 'var(--color-ocean-default)',
          color: 'var(--color-offwhite)',
          py: '20px',
          ':hover': {
            bgcolor: 'var(--color-ocean-highlight)',
            color: 'var(--color-dark-gray)'
          },
          height: '130px',
          maxWidth: '358px',
          mr: 2,
          flexDirection: 'column', // Align content vertically
          gap: 1 // Add some space between icon and text
        }}
        fullWidth
        size="large"
        variant="contained"
        startIcon={<DescriptionIcon sx={{mr:'10px'}} style={iconStyle}/>}
        onClick={() => setOpen(true)}
      >
        Progress Notes
      </Button>
      <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="md"
            fullScreen
            PaperProps={{
                style: {
                backgroundColor: 'rgba(140, 170, 100, 0.95)',
                boxShadow: 'none',
                marginTop: '180px',
                marginRight: '140px',
                marginLeft: '130px',
                height:'800px',
                marginBottom:'100px'
                },

                ml:'100px'
            }}
            >
            <IconButton
                sx={{
                position: "absolute",
                top: "8px",
                right: "8px",
                color: "grey.600",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                },
                }}
                onClick={handleClose}
                aria-label="close"
            >
                <CloseIcon
                sx={{
                    border: "2px solid #ff7f7f", // Light red border
                    borderRadius: "4px", // Adjust border radius as needed
                    padding: "4px", // Adjust padding as needed
                }}
                />
            </IconButton>

            <Box sx={{
                marginLeft:'200px',
                mt:'50px',
                mr:'30px'


              }}>
                <Typography
                  className="bold-text"
                  sx={{
                    
                    
                    color: 'var(--color-ocean-highlight)',
                    fontSize: '32px',
                  
                    
                    height: '56px',
                    maxWidth: '100%',
                    mr: 2,
                    ml:'20px',
                  }}
                  align="left"
                  variant="h4"
                  gutterBottom
                >
                  Please use the (Dropdown) to complete all paperwork relavent to your shift
                </Typography>

            </Box>
            <DialogContent sx={{ marginTop: '2px' }}>

                <PaperWorkDropDown />
                {/* <Timesheets/> */}
            </DialogContent>
        </Dialog>
    </div>
  );
};

export default ShiftNotesButton;
